import request from '@/utils/request'

// 查询
export function getTrack(data) {
  return request({
    url: '/clLabel/getTrack',
    method: 'POST',
    data
  })
}
export function queryTrack(data) {
  return request({
    url: '/shipPlan/queryRouting',
    method: 'POST',
    data
  })
}
